import { IEventEnrollment } from '../eventEnrollments/store';

export interface IAdminPlayerEnrollmentsStore {
  [clubId: number]: IEventEnrollment[];
}

export const adminPlayerEnrollmentsStore: IAdminPlayerEnrollmentsStore = [];
